import { getListData } from '@/service/main/system'

export interface CoreDataTrendParams {
  startTime: string
  endTime: string
  empId: string
}

export interface CoreDataTrendItem {
  date: string
  empId: string
  empName: string
  callDuration: number
  callCount: number
  liveData: number
  peiyangFbData: number
  yingxiaoFbData: number
  performanceAmount: number
  performanceCount: number
}

export function getCoreDataTrend(params: CoreDataTrendParams) {
  return getListData('/main/coreData/trend', params) as Promise<CoreDataTrendItem[]>
}
